import { doPost } from 'services/common'

const start = (breakId, stepId) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
  }

  return doPost(`/trivia/start`, payload)
}

const complete = (breakId, stepId) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
  }

  return doPost(`/trivia/complete`, payload)
}

const getTextTriviaAnswerResult = (triviaId, questionId, answerId) => {
  const body = {
    triviaId: triviaId,
    questionId: questionId,
    answerId: answerId,
  }

  return doPost('/trivia/answer', body)
}

const getTextTriviaFinalResult = (triviaId, resultId) => {
  const body = {
    triviaId: triviaId,
    resultId: resultId,
  }

  return doPost('/trivia/result', body)
}

export { start, complete, getTextTriviaAnswerResult, getTextTriviaFinalResult }
